import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { useAuth } from "@/contexts/AuthContext";
import PageHeader from "@/components/PageHeader";
import ExportButton from "@/components/ExportButton";
import { Badge } from "@/components/ui/badge";
import { Bot, User } from "lucide-react";

export default function AuditLogs() {
  const { activeCompanyId } = useAuth();
  const [items, setItems] = useState([]);
  useEffect(() => {
    (async () => {
      const params = activeCompanyId ? { company_id: activeCompanyId } : {};
      const { data } = await api.get("/audit", { params });
      setItems(data);
    })();
  }, [activeCompanyId]);
  return (
    <div className="flex flex-col h-full overflow-y-auto" data-testid="audit-page">
      <PageHeader
        title="Audit logs"
        subtitle="Every consequential action — human or AI — recorded here."
        actions={<ExportButton dataset="audit" companyId={activeCompanyId} />}
      />
      <div className="p-6 lg:p-8">
        <div className="border border-border rounded-sm overflow-hidden">
          <table className="tbl w-full">
            <thead><tr><th>When</th><th>Actor</th><th>Action</th><th>Record</th><th>Details</th></tr></thead>
            <tbody>
              {items.map((l) => (
                <tr key={l.id} data-testid={`audit-${l.id}`}>
                  <td className="font-mono text-xs text-muted-foreground">{(l.created_at || "").slice(0, 19).replace("T", " ")}</td>
                  <td>
                    <div className="flex items-center gap-2">
                      {l.ai_actor ? <Bot className="h-3.5 w-3.5 text-terracotta" /> : <User className="h-3.5 w-3.5 text-muted-foreground" />}
                      <span className="text-sm">{l.username || (l.ai_actor ? "AI Agent" : "system")}</span>
                    </div>
                  </td>
                  <td><Badge variant="outline" className="rounded-sm text-[10px] font-mono uppercase">{l.action}</Badge></td>
                  <td className="font-mono text-xs text-muted-foreground">{l.record_type}/{l.record_id?.slice(0, 8)}</td>
                  <td className="text-xs text-muted-foreground">{l.details || (l.new_value ? JSON.stringify(l.new_value).slice(0, 120) : "")}</td>
                </tr>
              ))}
              {items.length === 0 && <tr><td colSpan="5" className="text-center text-muted-foreground py-8">No activity yet.</td></tr>}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
